import React from 'react';
import SpanningWarningComponent from './SpanningWarningComponent';

function ComingSoon(){
  return <SpanningWarningComponent message="Coming Soon" />
}

export default ComingSoon;